module.exports = __webpack_public_path__ + "static/media/icon_sentaku2.43016eaf.svg";